const borders = {
    null: 0,
    small: 1,
    large: 2,
}

export default borders
